import {ZipCodeList} from "./ZipCodeList";
import {ZipCodeEdit} from "./ZipCodeEdit";
import {ZipCodeCreate} from "./ZipCodeCreate";

export default {
    list: ZipCodeList,
    create: ZipCodeCreate,
    edit: ZipCodeEdit
};
